<template>
  <div id="app">
    <TopNavbar />
    <div class="d-flex mx-0 flex-grow-1">
      <SideBar v-on:setTab="setActiveTab"  />
      <SideBarPanel v-bind:activetab="activeTab" />
      <CenterArea />
      <Layers  v-if="isLayersVisible" />
      <SlidesPanel />
    </div>
  </div>
</template>

<script>
import SideBar from './components/SideBar.vue'
import TopNavbar from "./components/Navbar.vue"
import SideBarPanel from "./components/SideBarPanel.vue"
import CenterArea from "./components/CenterArea.vue"
import Layers from './components/Layers.vue'
import SlidesPanel from "./components/SlidesPanel.vue"
import 'animate.css';
export default {
  name: 'App',
  components: {
    SideBar,
    TopNavbar,
    SideBarPanel,
    CenterArea,
    Layers,
    SlidesPanel,
  },
  data(){
    return {
      activeTab: "Templates"
    }
  },
  computed:{

    isLayersVisible() {
      return this.$store.getters.getShowLayersPanel;
    }
  },
  methods:{
    setActiveTab(text){
      
         this.activeTab = text;
         
    },
  }
}

</script>

<style>
.custonInput {
    padding: 0;
    width: 50px;
    color: #495057;
    border-radius: 3px;
    height: 40px;
    outline: none;
    background: none;
    border: none;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.text-gray-700 {
    color: rgb(73,80,87);
}
html {
  min-height: 100%;
  display: flex;
}

body {
  flex: 1;
}
.cursor-pointer{
  cursor: pointer;
}
.form-control-range {
  height: 2.19px;
  border: 0;
}
.noanchor:hover {
  text-decoration: none;
  color: inherit;
}
.moveable-control.moveable-border-radius {
    left: 40px!important;
}
#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}
#dropdown-form__BV_toggle_{
    background-color: transparent !important;
    padding: 3px 10px !important;
    border: none;
    color: rgb(73 80 87);
    font-weight: 500;
    box-shadow: none !important
    
  }
#dropdown-form__BV_toggle_ i{
  font-size: 10px;
  margin-left: 3px;
    
  }
#dropdown-form__BV_toggle_ i.fa-angle-up{
display: none;
    
  }
#dropdown-form__BV_toggle_[aria-expanded="true"]{
  background-color: rgb(236 239 253) !important;
    color: rgb(66 99 235);
    
  }
#dropdown-form__BV_toggle_[aria-expanded="true"] i.fa-angle-down{
display: none;
    
  }
#dropdown-form__BV_toggle_[aria-expanded="true"] i.fa-angle-up{
display: inline-block;
    
  }
#dropdown-2__BV_toggle_ {
  height: 2rem !important;
  padding: 0 !important;
  width: 1rem !important;
}
ul[aria-labelledby="dropdown-2__BV_toggle_"]{
  min-width: 6rem !important;
  background-color: #161E2E !important;
}
ul[aria-labelledby="dropdown-2__BV_toggle_"] a{
  color: #9FA6B2 !important;
  font-size: 13px;

}
ul[aria-labelledby="dropdown-2__BV_toggle_"] li:hover a{
  background-color: #252F3F !important;
}
.w-76 {
  width: 19rem;
}

.canvas-box.hideit{
  display: none !important;
}
#Resolution-modal___BV_modal_footer_ {
  justify-content: space-between !important;
}
.ytp-chrome-top.ytp-show-cards-title{
  display: none !important;
}
.activeIconBtn svg{
  background-color: #ccc;
  border-radius: 5px;
}
#Preview-modal___BV_modal_footer_{
  display: block !important;
  border: 0 !important;
}
#Preview-modal___BV_modal_content_ { 
  border: 0 !important;
  width: 100%;
    height: 100%;
  background-color: transparent;
}
#Preview-modal___BV_modal_body_{
  padding: 0 !important;
}
#Preview-modal .modal-dialog{
  height: 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-top:0 !important;
}

</style>
